import { ApplicantState, AgencyState, JurisdictionState, AppointmentGroupState, AppointmentsForRestore, FormStateWithEnteredValues, EmbeddedValueForPdf } from '../types';

interface pdfCreation {
  formValue: FormStateWithEnteredValues;
}
export class PdfCreation implements pdfCreation {
  
  formValue: FormStateWithEnteredValues;

  constructor(formValue: FormStateWithEnteredValues) {
    this.formValue = formValue;
  }

  /**
   * PDF作成のためのデータを取得するメソッドです。
   * @param {1 | 2} pdfType 作成するPDFの種類（1:包括委任状提出書, 2:包括委任状）
   * @return {object} PDF作成のためのデータ
   */
  public getFormValue(pdfType: 1 | 2): any {
    const appointmentsText = this.getAppointmentTexts(this.formValue.appointmentGroups);
    const otherAppointmentsText = this.formValue.otherAppointments.length === 1 && this.formValue.otherAppointments[0] === '' ? '' : this.formValue.otherAppointments.map((otherAppointment) => {
      return `１　${otherAppointment}`;
    }).join('\n');
    const additionalItemsText = this.formValue.additionalItems.map((additionalItem) => {
      return additionalItem;
    }).join('\n');
    return {
      info: {
        title: this.formValue.documentName.value,
        author: '特許庁審査業務部',
        subject: '特殊申請書類作成支援ツール',
        keywords: JSON.stringify(this.getEmbeddedValueForPdf()),
      },
      content: pdfType === 1 ?
        [
          {text: this.formValue.documentName.value, alignment: 'center', margin: [25, 10, 25, 10]},
          {text: `（${this.charToJapaneseCalendar(this.formValue.submissionDate.value)}）`, alignment: 'right', margin: [25, 10, 25, 10]},
          {text: `特許庁長官            殿`, margin: [25, 10, 25, 10]},
          {text: `１    提出者`, margin: [25, 10, 25, 10]},
          {text: this.getApplicantForPdf(pdfType, this.formValue.applicant, this.isAgencyProceedings(this.formValue.agencies)), margin: [75, 0, 25, 0]},
          {text: `２    選任した代理人`, margin: [25, 10, 25, 10]},
          {text: this.getAgenciesForPdf(pdfType, this.formValue.agencies), margin: [75, 0, 25, 0]},
          {text: `${this.getAgenciesForPdf(3, this.formValue.agencies) !== '' ?  '３    代理人' : ''}`, margin: this.getAgenciesForPdf(3, this.formValue.agencies) !== '' ?  [25, 10, 25, 10] : [0, 0, 0, 0]},
          {text: `${this.getAgenciesForPdf(3, this.formValue.agencies) !== '' ?  this.getAgenciesForPdf(3, this.formValue.agencies) : ''}`, margin: [75, 0, 25, 0]},
          {text: `${this.getAgenciesForPdf(3, this.formValue.agencies) !== '' ?  '４' : '３'}    提出物件の目録`, margin: [25, 10, 25, 10]},
          {text: additionalItemsText, margin: [75, 0, 25, 0]}
        ]
        :
        [
          {text: '包括委任状', alignment: 'center', margin: [25, 10, 25, 10]},
          {text: `${this.charToJapaneseCalendar(this.formValue.delegationDate.value)}`, alignment: 'right', margin: [25, 10, 25, 10]},
          {text: `私は、`, margin: [25, 10, 25, 10]},
          {text: `${this.getAgenciesForPdf(2, this.formValue.agencies)}`, margin: [ 160, 10, 25, 10]},
          {text: `をもって代理人として下記事項を委任します。`, margin: [25, 10, 25, 10]},
          {text: '記', alignment: 'center', margin: [25, 20, 25, 10]},
          this.getAppointmentTextsForPdf(appointmentsText).map((item, index) => {
            if(item.indexOf('　') !== 0) {
              return {text: item, margin: [37, index === 0 ? 10 : 0, 25, index === this.getAppointmentTextsForPdf(appointmentsText).length - 1 ? 10 : 0]};
            } else {
              return {text: `１${item}`, margin: [25, index === 0 ? 10 : 0, 25, index === this.getAppointmentTextsForPdf(appointmentsText).length - 1 && otherAppointmentsText === '' ? 10 : 0]};
            }
          }),
          otherAppointmentsText !== '' ? {text: otherAppointmentsText, margin: [25, 0, 25, 10]} : {},
          {text: `${this.getApplicantForPdf(2, this.formValue.applicant, false)}`, margin: [150, 30, 25, 10]},
        ],
      defaultStyle: {
        font: 'IPA_mincho',
        fontSize: 12,
        alignment: 'left',
        lineHeight: 1.7,
        margin: [25, 0, 25, 0]
      },
    };
  }

  public getEmbeddedValueForPdf = (): EmbeddedValueForPdf => {
    return {
      '書類名': this.formValue.documentName.value,
      '提出日': this.formValue.submissionDate.value,
      '委任日': this.formValue.delegationDate.value,
      '提出者': {
        '識別番号': this.formValue.applicant.identificationNumber.value,
        '郵便番号': this.formValue.applicant.postalCode.value,
        '住所又は居所': this.formValue.applicant.address.value,
        '氏名又は名称': this.formValue.applicant.name.value,
        '代表者': this.formValue.applicant.representative.value
      },
      '代理人': this.formValue.agencies.map((agency) => {
        return ({
          '手続実行者フラグ': agency.isProcedureExecutor,
          '識別番号': agency.identificationNumber.value,
          '住所又は居所': agency.address.value,
          '氏名又は名称': agency.name.value,
          '代表者': agency.representative.value
        });
      }),
      '委任事項': {
        '委任コード': this.getAppointmentCodes(this.formValue.appointmentGroups),
        'テキスト': this.getAppointmentTexts(this.formValue.appointmentGroups)
      },
      'その他の委任事項': this.formValue.otherAppointments,
      '提出物件': this.formValue.additionalItems
    };
  }

  /**
   * フォームにエラーが存在しているか判断するメソッドです。
   * @return {boolean} - エラー有無
   */
  public isError = (): boolean => {
    let result = false;
    result = this.formValue.documentName.errorMessage !== '' ? true : result;
    result = this.formValue.submissionDate.errorMessage !== '' ? true : result;
    result = this.formValue.delegationDate.errorMessage !== '' ? true : result;
    result = this.formValue.applicant.identificationNumber.errorMessage !== '' ? true : result;
    result = this.formValue.applicant.postalCode.errorMessage !== '' ? true : result;
    result = this.formValue.applicant.address.errorMessage !== '' ? true : result;
    result = this.formValue.applicant.name.errorMessage !== '' ? true : result;
    result = this.formValue.applicant.representative.errorMessage !== '' ? true : result;
    this.formValue.agencies.forEach((agency) => {
      result = agency.identificationNumber.errorMessage !== '' ? true : result;
      result = agency.address.errorMessage !== '' ? true : result;
      result = agency.name.errorMessage !== '' ? true : result;
      result = agency.representative.errorMessage !== '' ? true : result;
    });
    return result;
  }

  /**
   * 特定の委任IDを含んでいるか否かを判定するメソッドです。
   * @param {string} appointmentId - チェック対象の委任ID
   * @return {boolean} - 存在有無
   */
  public hasSpecificAppointmentId = (appointmentId: string): boolean => {
    let result = false;
    this.formValue.appointmentGroups.forEach((appointmentGroup) => {
      result = appointmentGroup.masterAppointment.appointmentId === appointmentId && appointmentGroup.masterAppointment.isChecked === true ? true : result;
    });
    return result;
  }

  /**
   * 文字列（YYYY-MM-DD）を和暦（令和YY年MM月DD日）に変換する
   * @param {string} inputValue YYYY-MM-DD形式の文字列
   * @return {string} 令和YY年MM月DD日形式に変換した文字列
   */
  private getAppointmentsForRestore = (): AppointmentsForRestore[] => {
    const tempAppointmentGroupsValue: AppointmentsForRestore[] = [];
    this.formValue.appointmentGroups.forEach((appointmentGroup) => {
      if(appointmentGroup.masterAppointment.isChecked === true) {
        const tempServantAppointmentIds: string[] = [];
        appointmentGroup.servantAppointments.forEach((servantAppointment) => {
          if(servantAppointment.isChecked === true) {
            tempServantAppointmentIds.push(servantAppointment.appointmentId);
          }
        });
        const tempJurisdicionts: string[] = [];
        appointmentGroup.jurisdictions.forEach((jurisdiction) => {
          if(jurisdiction.isChecked === true) {
            tempJurisdicionts.push(jurisdiction.jurisdictionCode);
          }
        });
        tempAppointmentGroupsValue.push({
          '委任事項（メイン）ID': appointmentGroup.masterAppointment.appointmentId,
          '委任事項（サブ）ID': tempServantAppointmentIds,
          '法域': tempJurisdicionts
        });
      }
    });

    return tempAppointmentGroupsValue;
  }

  /**
   * 文字列（YYYY-MM-DD）を和暦（令和YY年MM月DD日）に変換する
   * @param {string} inputValue YYYY-MM-DD形式の文字列
   * @return {string} 令和YY年MM月DD日形式に変換した文字列
   */
  private charToJapaneseCalendar = (inputValue: string): string => {
    return new Intl.DateTimeFormat('ja-JP-u-ca-japanese', {year: 'numeric', month: 'long', day: 'numeric'}).format(new Date(inputValue));
  }

  /**
   * 代理人手続か否かを取得するプライベートメソッドです。
   * @param {AgencyState[]} agecnies 代理人ステート（複数）
   * @return {boolean} 代理人手続か否か
   */
  private isAgencyProceedings = (agencies: AgencyState[]): boolean => {
    let result = false;
    agencies.forEach((agency) => {
      result = agency.isProcedureExecutor ? true : result;
    });
    return result;
  }

  /**
   * PDF上の「提出者（委任者）」欄に入力された申出人情報をPDF上に記載するためのフォーマット（文字列変換）処理をおこなう内部メソッド
   *     （フォーマット例：pdftype === 1）
   *          識別番号  NNNNNNNNN
   *          郵便番号  NNN-NNNN
   *          住所（居所）  東京都千代田区霞ヶ関３－４－３
   *          氏名（名称）  株式会社XXXX
   *          代表者  特許　太郎
   *     （フォーマット例：pdftype === 2）
   *          識別番号 NNNNNNNNN  株式会社XXXX
   * @param {1 | 2} pdfType - 作成するPDFの種類（1:包括委任状提出書の「申出人」用フォーマット, 2:包括委任状の委任者フォーマット）
   * @param {Applicant} applicant - 出願人情報
   * @param {boolean} isAgencyProceedings - 代理人手続か否か
   * @returns {string} - 提出者（委任者）情報
   */
  private getApplicantForPdf = (pdfType: 1 | 2, applicant: ApplicantState, isAgencyProceedings: boolean): string => {
    if(pdfType === 1) {
      return `${applicant.identificationNumber.value !== '' ? `識別番号    ${applicant.identificationNumber.value}\n` : ''}${applicant.postalCode.value !== '' ? `郵便番号    ${applicant.postalCode.value}\n` : ''}${applicant.address.value !== '' ? `住所又は居所    ${applicant.address.value}\n` : ''}${applicant.name.value !== '' ? `氏名又は名称    ${applicant.name.value}\n` : ''}${applicant.representative.value !== '' && isAgencyProceedings === false ? `代表者    ${applicant.representative.value}\n` : ''}\n`;
    } else if(pdfType === 2) {
      return `${applicant.address.value !== '' ? `住所（居所）    ${applicant.address.value}\n` : ''}${applicant.name.value !== '' ? `氏名（名称）    ${applicant.name.value}\n` : ''}${applicant.representative.value !== '' ? `代表者    ${applicant.representative.value}\n` : ''}\n`;
    }
    return '';
  };

  /**
   *  PDF上の「代理人（受任者）」欄に入力された代理人（受任者）情報をPDF上に記載するためのフォーマット（文字列変換）処理
   *     （フォーマット例：pdftype === 1）
   *          識別番号  NNNNNNNNN
   *          住所（居所）  東京都千代田区霞ヶ関３－４－３
   *          氏名（名称）  株式会社XXXX
   *     （フォーマット例：pdftype === 2）
   *          識別番号 NNNNNNNNN  株式会社XXXX
   *     （フォーマット例：pdftype === 3）
   *          識別番号  NNNNNNNNN
   *          住所（居所）  東京都千代田区霞ヶ関３－４－３
   *          氏名（名称）  株式会社XXXX
   *          代表者  特許　太郎
   * @param {number} pdfType 作成するPDFの種類（1:包括委任状提出書の「選任した代理人」用フォーマット, 2:包括委任状の「受任者」, 3:包括委任状提出書の「代理人（手続者）」用フォーマット）
   * @return {string} 文字列変換した代理人情報
   */
  private getAgenciesForPdf = (pdfType: 1 | 2 | 3, agecnies: AgencyState[]) => {
    let result = '';
    if(pdfType === 1) {
      agecnies.forEach((agency) => {
        result += `${agency.identificationNumber.value ? `識別番号    ${agency.identificationNumber.value}\n` : ''}${agency.address.value ? `住所又は居所    ${agency.address.value}\n` : ''}${agency.name.value ? `氏名又は名称    ${agency.name.value}\n` : ''}\n`;
      });
    } else if(pdfType === 2) {
      agecnies.forEach((agency) => {
        result += `識別番号${agency.identificationNumber.value} ${agency.name.value}\n`;
      });
    } else if(pdfType === 3) {
      agecnies.forEach((agecny) => {
        if(agecny.isProcedureExecutor === true) {
          result += `${agecny.identificationNumber.value ? `識別番号    ${agecny.identificationNumber.value}\n` : ''}${agecny.address.value ? `住所又は居所    ${agecny.address.value}\n` : ''}${agecny.name.value ? `氏名又は名称    ${agecny.name.value}\n` : ''}${agecny.representative.value ? `代表者    ${agecny.representative.value}\n` : ''}\n`;
        }
      });
    }
    return result;
  }

  /**
   * PDF用の委任事項テキストを取得する関数です。
   * @param {AppointmentGroupState[]} appointmentGroups - 委任事項グループ（複数）
   * @returns {string[]} - 
   */
  private getAppointmentTexts = (appointmentGroups: AppointmentGroupState[]): string[] => {
    const result: string[] = [];
    appointmentGroups.forEach((appointmentGroup: AppointmentGroupState) => {
      if(appointmentGroup.masterAppointment.isChecked === true) {

        if(appointmentGroup.masterAppointment.appointmentId === '12' || appointmentGroup.masterAppointment.appointmentId === '16') {
          // 変更出願と優先権主張の場合

          const checkedServantAppointmentValues: string[] = [];
          appointmentGroup.servantAppointments.forEach((servantAppointment) => {
            if(servantAppointment.isChecked === true) {
              checkedServantAppointmentValues.push(servantAppointment.value);
            }
          });

          appointmentGroup.jurisdictions.forEach((jurisdcition) => {
            if(jurisdcition.isChecked === true) {
              result.push(`${appointmentGroup.masterAppointment.value.replace('＠', jurisdcition.value)}${checkedServantAppointmentValues.length !== 0 ? `及び${checkedServantAppointmentValues.join('及び')}` : ''}`);
            }
          });

        } else {
          // 変更出願と優先権主張以外の場合

          const checkedJurisdictionValues: string[] = [];
          appointmentGroup.jurisdictions.forEach((jurisdcition: JurisdictionState) => {
            if(jurisdcition.isChecked === true) {
              checkedJurisdictionValues.push(jurisdcition.value);
            }
          });
          const jurisdcitionsText = checkedJurisdictionValues.length >= 2 ? `${checkedJurisdictionValues.slice(0, -1).join('、')}及び${checkedJurisdictionValues.slice(-1)}` : (checkedJurisdictionValues.length === 1 ? checkedJurisdictionValues[0] : '');
  
          const checkedServantAppointmentValues: string[] = [];
          appointmentGroup.servantAppointments.forEach((servantAppointment) => {
            if(servantAppointment.isChecked === true) {
              checkedServantAppointmentValues.push(servantAppointment.value);
            }
          });
          const servantAppointmentsText = checkedServantAppointmentValues.length >= 2 ? `${checkedServantAppointmentValues.join('及び')}` : (checkedServantAppointmentValues.length === 1 ? checkedServantAppointmentValues[0] : '');
  
          const fillerWord: string = servantAppointmentsText !== '' ? (appointmentGroup.masterAppointment.appointmentId === '11' ? '並びにこれらの出願に関する' : (appointmentGroup.masterAppointment.appointmentId === '21' ? '並びに' : '及び')) : '';
  
  
          result.push(`${appointmentGroup.masterAppointment.value.replace('＠', jurisdcitionsText)}${fillerWord}${servantAppointmentsText}`);
        }
      }
    });
    return result;
  }

  /**
   * PDFに委任事項テキストを埋め込むために配列を整形する関数です。
   * @param {AppointmentGroupState[]} appointmentGroups - 委任事項グループ（複数）
   * @returns {string[]} - 
   */
  private getAppointmentTextsForPdf = (appointmentsText: string[]): string[] => {
    const result: string[] = [];
    appointmentsText.forEach((item) => {
      item = `　${item}`;
      if([...item].length <= 36) {
        result.push(item);
      } else {
        let temp = '';
        [...item].forEach((char, index) => {
          if(index !== 0 && index % 37 === 0) {
            result.push(temp);
            temp = char;
          } else {
            temp += char;
            if(index === [...item].length - 1) {
              result.push(temp)
            }
          }
        });
      }
    });
    return result;
  }

  /**
   * 権限コードを取得する関数です。
   * @param {AppointmentGroup[]} appointmentGroups - 委任事項
   * @returns {string[]} - 申請人登録システム上の権限コード（複数）
   */
  private getAppointmentCodes = (appointmentGroups: AppointmentGroupState[]): string[] => {
    const result: string[] = [];
    let isZ15Checked: boolean = false;
    appointmentGroups.forEach((appointmentGroup: AppointmentGroupState) => {
      if(appointmentGroup.masterAppointment.isChecked === true) {
        
        if(appointmentGroup.masterAppointment.appointmentId === '15') {
          isZ15Checked = true;
        }

        const checkedServantAppointmentValues: string[] = [];
        appointmentGroup.servantAppointments.forEach((servantAppointment) => {
          if(servantAppointment.isChecked === true) {
            checkedServantAppointmentValues.push(servantAppointment.appointmentId);
          }
        });

        appointmentGroup.jurisdictions.forEach((jurisdcition: JurisdictionState) => {
          if(jurisdcition.isChecked === true) {

            if(jurisdcition.appointmentCode === '') {
              result.push(`${jurisdcition.yonpoCode}${appointmentGroup.masterAppointment.appointmentId}`);
              checkedServantAppointmentValues.forEach((servantAppointment) => {
                result.push(`${jurisdcition.yonpoCode}${servantAppointment}`);
              })
            } else if(jurisdcition.appointmentCode !== 'Z99') {
              result.push(jurisdcition.appointmentCode);
            }
          }
        });

      }
    });

    if(isZ15Checked) {
      let yonpos: string[] = [];
      result.forEach((appointmentCode) => {
        yonpos.push(appointmentCode.replace(/[^PUDT]/g, ''));
      });
      yonpos = Array.from(new Set(yonpos));
      yonpos.forEach((yonpo) => {
        result.push(`${yonpo}15`);
      });
    }
    return Array.from(new Set(result));
  }
}

/**
  * フォームにエラーが存在しているか判断するメソッドです。
  * @param {FormStateWithEnteredValues} - 入力されたフォームの値
  * @return {boolean} - エラー有無
  */
export const isError = (formValue: FormStateWithEnteredValues): boolean => {
  let result = false;
  result = formValue.documentName.value === '' || formValue.documentName.errorMessage !== '' ? true : result;
  result = formValue.submissionDate.value === '' || formValue.submissionDate.errorMessage !== '' ? true : result;
  result = formValue.delegationDate.value === '' || formValue.delegationDate.errorMessage !== '' ? true : result;
  result = formValue.applicant.identificationNumber.errorMessage !== '' ? true : result;
  result = formValue.applicant.postalCode.errorMessage !== '' ? true : result;
  result = formValue.applicant.address.value === '' || formValue.applicant.address.errorMessage !== '' ? true : result;
  result = formValue.applicant.name.value === '' || formValue.applicant.name.errorMessage !== '' ? true : result;
  result = formValue.applicant.representative.errorMessage !== '' ? true : result;
  formValue.agencies.forEach((agency) => {
    result = agency.identificationNumber.value === '' || agency.identificationNumber.errorMessage !== '' ? true : result;
    result = agency.address.errorMessage !== '' ? true : result;
    result = agency.name.value === '' || agency.name.errorMessage !== '' ? true : result;
    result = agency.representative.errorMessage !== '' ? true : result;
  });
  return result;
} 